module.exports = __webpack_public_path__ + "media/images/restaurant bistronomique-178a6530ddc855687caf1a375f718cba.svg";